import { useHistory } from "react-router";
import FlechaIzquierdaIcon from "_+_Portal/assets/images/generico/FlechaIzquierdaIcon";
import "./BtnVolver.css";

const BtnVolver = ({ to, onClick, label = "Volver" }) => {
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      history.push(to);
    }
  };

  return (
    <button onClick={handleClick} className="ptur-btnVolver">
      <FlechaIzquierdaIcon color="white" />
      <span className="ptur-btnVolver-txt rb16m">{label}</span>
    </button>
  );
};

export default BtnVolver;
